import { Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// redux
import { useDispatch, useSelector } from "../../../redux/store";
import { setCreatorDetails } from "../../../redux/slices/creator";
// config
import colors from "../../../config/colors";
// components
import {
  ProfileInfo,
  RecentBrands,
  Tabs,
} from "../../../components/Discover/details";
// tabs
import ContentTab from "./ContentTab";
import OverviewTab from "./OverviewTab";
import SimilarCreatorsTab from "./SimilarCreatorsTab";
import { Box } from "@mui/system";
import CreatorBio from "./CreatorBio";
import {
  ACTION,
  CATEGORY,
  PAGE,
  SCREEN,
  triggerGa,
} from "../../../utils/gaUtils";

const CreatorDetails = () => {
  const dispatch = useDispatch();
  const creatorDetails = useSelector((state) => state.creator.creatorDetails);
  const selectedTab = useSelector((state) => state.creator.selectedDetailsTab);

  const handleCloseDrawer = () => {
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.PROFILE_CLOSE,
      label: creatorDetails?.username,
      page: PAGE.CREATOR_DISCOVER,
      screenName: SCREEN.CREATOR_DRAWER,
    });
    dispatch(setCreatorDetails(null));
  };

  return (
    <Stack
      sx={{
        flex: 1,
        height: "100vh",
        backgroundColor: colors.primary100,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Close Button at Top */}
      <Box sx={{ p: "24px", flexShrink: 0 }}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent="flex-end"
        >
          <Box
            sx={{
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            data-cy="creator-details-close-button"
            onClick={handleCloseDrawer}
          >
            <CloseIcon
              sx={{
                fontSize: "24px",
                height: "24px",
                width: "24px",
                fontWeight: 900,
                lineHeight: "24px",
              }}
            />
          </Box>
        </Stack>
      </Box>

      {/* Sticky Header Section */}
      <Box
        sx={{
          p: "0px 24px",
          pb: "16px",
          backgroundColor: colors.primary100,
          flexShrink: 0,
        }}
      >
        <Stack gap="24px">
          <ProfileInfo item={creatorDetails} />
          <CreatorBio bio={creatorDetails?.bio} />
          <RecentBrands brands={creatorDetails?.recent_brands || []} />
          <Tabs />
        </Stack>
      </Box>

      {/* Scrollable Tab Content Section */}
      <Box
        sx={{
          flex: 1,
          p: "24px",
          pt: 0,
          overflow: "auto",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {selectedTab === "overview" && <OverviewTab details={creatorDetails} />}
        {selectedTab === "content" && (
          <ContentTab
            topContent={creatorDetails?.top_posts || []}
            wishlink_username={creatorDetails?.wishlink_username}
            instagram_username={creatorDetails?.username}
          />
        )}
        {selectedTab === "similar-creators" && (
          <SimilarCreatorsTab
            wishlink_username={creatorDetails?.wishlink_username}
          />
        )}
      </Box>
    </Stack>
  );
};
export default CreatorDetails;
